import Button1 from "../assets/sfx/button-1.mp3";
import Button2 from "../assets/sfx/button-2.mp3";
import ElementHover from "../assets/sfx/button-hover.mp3";
import LightSwitch from "../assets/sfx/light-switch.mp3";

const playNavSelect = () => {
	const sfx = new Audio(Button1);
	sfx.play();
};

const playButtonSelect = () => {
	const sfx = new Audio(Button2);
	sfx.play();
};

const playElementHover = () => {
	const sfx = new Audio(ElementHover);
	sfx.play();
}

const playSwitchToggle = () => {
	const sfx = new Audio(LightSwitch);
	sfx.play();
}

export { playNavSelect, playButtonSelect, playElementHover, playSwitchToggle };